
import AnimationOverlay from '~/components/core/AnimationOverlay';
export default {
  components: { AnimationOverlay },
  props: {
    title: {
      type: String,
      default: ""
    },

    date: {
      type: String,
      default: ""
    },
    shortDesc: {
      type: String
    }
  }
}

